/**
 * @file PoQtyCell.js
 * @version 2.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-08
 * @modified 2026-10-20
 *
 * A PO line's quantity in the PO window, in its own unit AND the tonnes it
 * comes to (Cam, 20 Oct 2026 — utils/qtyWithTonnes, laid out by
 * QtyWithTonnes): "40 × 25kg bag" over "1 pallet · 1.00 T"; a tonne line
 * "12.50 T"; a None line a plain count; an unknown unit the bare number. The
 * ordered and the supplied quantity use it alike, so the two can be compared.
 *
 * The PO's "Show quantities as" still decides which comes first (`mode`):
 * Tonnes first puts "1.00 T" on top with "40 × 25kg bag · 1 pallet" beneath.
 * The PDF keeps its own two lines (the server's utils/poQtyDisplay).
 *
 * 2.0.0 (2026-10-20, Cam): worked out here from the line's weights instead of
 * the server's qtyDisplay text, so the supplied quantity reads the same way
 * and a tonne line says "T" in one place. `line` carries unitWeightKg /
 * itemUnitWeightKg / qtyPerPallet / itemQtyPerPallet / pallets / kind.
 * `supplied` leaves out the line's own pallet figure (it is the ordered one's);
 * `unitsOnly` shows the unit alone (a PO-H line, whose Weight and Pallets
 * columns already say the rest).
 */

import React from 'react';
import QtyWithTonnes from './QtyWithTonnes';

function PoQtyCell({ quantity, line = {}, mode = null, supplied = false, unitsOnly = false, empty = '-' }) {
  return (
    <QtyWithTonnes
      quantity={quantity}
      line={line}
      order={mode === 'tonnes' ? 'tonnes' : 'units'}
      pallets={supplied ? null : (line?.pallets ?? null)}
      kind={line?.kind === 'haulage' ? 'haulage' : null}
      empty={empty}
      unitsOnly={unitsOnly}
    />
  );
}

export default PoQtyCell;
